import React from 'react';
import { createRoot } from 'react-dom/client';
import Pages from './Pages';

const root = createRoot(document.getElementById('dads-root-chakra'));
root.render(<Pages />);
